/** The audio field: `media-uploader.hook` restricted to the audio types the endpoint accepts. */
import type { UseAssessmentMediaUploaderReturn } from './media-uploader.hook'

import { useAssessmentMediaUploader } from './media-uploader.hook'

/** The endpoint checks MIME types (`audio/mpeg`, `audio/mp4`, `audio/x-m4a`, `audio/webm`,
 *  `video/webm`, `audio/ogg`, `audio/wav`, `audio/x-wav`); these are the extensions those types
 *  arrive as. The check here is by extension, so an audio-only `.webm` the browser labels
 *  `video/webm` passes it too. */
export const ASSESSMENT_AUDIO_ACCEPT: string[] = ['.mp3', '.m4a', '.mp4', '.webm', '.ogg', '.oga', '.wav']

/** 80 MB — `App\Constants\File::MAX_SIZE_KB`, the endpoint's own limit. */
export const ASSESSMENT_AUDIO_MAX_SIZE = 81920 * 1024

export interface UseAudioUploaderOptions {
  value: () => string | undefined
  onChange: (value: string) => void
}

export const useAudioUploader = ({ value, onChange }: UseAudioUploaderOptions): UseAssessmentMediaUploaderReturn =>
  useAssessmentMediaUploader({
    value,
    onChange,
    accept: ASSESSMENT_AUDIO_ACCEPT,
    maxSize: ASSESSMENT_AUDIO_MAX_SIZE,
    cannotUploadHint: 'Save the assessment template before uploading audio.',
  })
